import {TOGGLE_BUS_SEAT_LAYOUT,UPDATE_SELECTED_BUS_INFO,UPDATE_SELECTED_BUS_DATA,UPDATE_RATING_REVIEW_DATA,UPDATE_BUS_DETAILS} from '../helpers/constants';
import {ITOGGLE_BUS_SEAT_LAYOUT,IUPDATE_SELECTED_BUS_INFO,IUPDATE_SELECTED_BUS_DATA,IUPDATE_BUS_DETAIL,IUPDATE_BUS_DETAIL_DATA}from '../helpers/validation';



  export function updateSelectedBusInfo(actionData:any): IUPDATE_SELECTED_BUS_INFO {
    return {
      type:UPDATE_SELECTED_BUS_INFO,
      actionData
    }
    
  }
export function updateSelectedBusData(actionData:any):IUPDATE_SELECTED_BUS_DATA{
return {
  type:UPDATE_SELECTED_BUS_DATA,
  actionData
}
}
export function updateRatingReviewData(actionData:any) :any{
  return {
    type:UPDATE_RATING_REVIEW_DATA,
    actionData
  }
  
}
export function updateBusDetailLoading(actionData:IUPDATE_BUS_DETAIL_DATA):IUPDATE_BUS_DETAIL{
  return {
    type:UPDATE_BUS_DETAILS,
    actionData
  }
}